export enum QuestionType {
  SingleChoice = 0,
  MultipleChoice = 1,
  FreeText = 2
}